import React from "react";
import CollapsibleCard from "../common/CollapsibleCard";

const renderMiniToggle = (label, isVisible, onToggle, color) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
        <span style={{ fontSize: '12px', color: '#4B4A4A', fontWeight: 600 }}>{label}</span>
        <div onClick={onToggle} style={{ width:36, height:20, borderRadius:20, position:'relative', cursor:'pointer', backgroundColor: isVisible ? color : '#D1D5DB', transition:'background-color 0.2s' }}>
            <div style={{ width:16, height:16, borderRadius:'50%', backgroundColor:'white', position:'absolute', top:2, left: isVisible ? 18 : 2, transition:'left 0.2s ease', boxShadow:'0 1px 2px rgba(0,0,0,0.2)' }}/>
        </div>
    </div>
);

export default function IncidenciasPanel({ 
    displayIncidents, groupedIncidents, incidentVisibility, 
    handleIncidentGroupToggle, toggleIncidentPath, handleOpenRevertIncidentModal 
}) {
    if (displayIncidents.length === 0) {
        return (
            <div style={{ textAlign: "center", padding: "40px 10px", color: "#9CA3AF" }}>
                <span style={{ fontSize: '24px', marginBottom: '10px', display:'block' }}>✅</span>
                <p style={{ fontSize: '13px', fontWeight: 500 }}>No hay incidencias reportadas</p>
            </div>
        );
    }

    return (
        <>
            {Object.entries(groupedIncidents).map(([cityName, cityIncidents]) => {
                const isGroupActive = cityIncidents.some(inc => {
                    const vis = incidentVisibility[inc.rouId] || { original: true, new: true };
                    return vis.original || vis.new;
                });

                return (
                    <CollapsibleCard 
                        key={cityName} 
                        title={cityName} 
                        subtitle={`${cityIncidents.length} ruta(s) con alerta`} 
                        isActive={isGroupActive}
                        defaultExpanded={true}
                        onToggleActive={() => handleIncidentGroupToggle(cityIncidents)}
                    >
                        {cityIncidents.map((inc, index) => {
                            const vis = incidentVisibility[inc.rouId] || { original: true, new: true };
                            return (
                                <div key={index} style={{ padding: '12px 0', borderBottom: index < cityIncidents.length - 1 ? '1px dashed #E5E7EB' : 'none' }}>
                                    <h4 style={{ margin: '0 0 6px 0', fontSize: '14px', color: '#1F2937' }}>🚨 {inc.routeName}</h4>
                                    <p style={{ margin: 0, fontSize: '11px', color: '#6B7280', lineHeight: 1.4 }}>{inc.message}</p>
                                    <div style={{ marginTop: '12px', background: '#F9FAFB', padding: '10px', borderRadius: '8px' }}>
                                        {renderMiniToggle("Ruta Original", vis.original, () => toggleIncidentPath(inc.rouId, 'original'), "#3B82F6")}
                                        {renderMiniToggle("Desvío (Incidencia)", vis.new, () => toggleIncidentPath(inc.rouId, 'new'), "#EF4444")}
                                        
                                        <button 
                                            onClick={() => handleOpenRevertIncidentModal(inc)}
                                            style={{ 
                                                width: '100%', marginTop: '16px', background: '#FFF1F2', 
                                                color: '#EF4444', border: '1px solid #FECDD3', padding: '10px', 
                                                borderRadius: '8px', fontWeight: 600, cursor: 'pointer', 
                                                transition: 'all 0.2s', display: 'flex', justifyContent: 'center', 
                                                alignItems: 'center', gap: '8px', fontSize: '13px' 
                                            }}
                                            onMouseOver={(e) => { e.currentTarget.style.background = '#FEE2E2'; e.currentTarget.style.borderColor = '#FCA5A5'; }}
                                            onMouseOut={(e) => { e.currentTarget.style.background = '#FFF1F2'; e.currentTarget.style.borderColor = '#FECDD3'; }}
                                        >
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                                                <path d="M3 3v5h5"></path>
                                            </svg>
                                            Revertir cambios del desvío
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </CollapsibleCard>
                );
            })}
        </>
    );
}